import * as React from 'react';
import { SVGProps } from 'react';

const IconSaveSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 1A1.75 1.75 0 0 0 1 2.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 15 13.25V5.225c0-.464-.184-.91-.513-1.238l-2.474-2.474A1.75 1.75 0 0 0 10.775 1H2.75ZM11 3H3v2h8V3Zm-3 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
  </svg>
);
export default IconSaveSizeS;
